import { CartographyResourceInfos } from './cartography-resource-infos';
import { CartographyResourceBbxStatusEnum } from '../../enum/cartography-resource-bbx-status.enum';

export class CartographyResourceInfosStatusBbx extends CartographyResourceInfos {
  public status: CartographyResourceBbxStatusEnum;

  constructor(idResource: string, status: CartographyResourceBbxStatusEnum) {
    super(idResource);
    if (status < 0 || status > 3) {
      this.status = 3;
      return;
    }
    this.status = status;
  }
}
